import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const TalkingPointsToParagraph = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12713"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12713)">
          <rect
            x="-33.4546"
            y="-2"
            width="197.706"
            height="114"
            rx="6.37762"
            fill="#F4F4F4"
          />
          <rect
            x="31.7168"
            y="21.7166"
            width="49.028"
            height="66.4525"
            rx="3.502"
            fill="white"
            stroke="#191919"
            strokeWidth="1.1958"
          />
          <path
            d="M77.3068 22.1437L32.1438 84.4622C32.1438 84.4622 32.461 86.1663 33.0257 86.7814C33.5903 87.3965 34.3561 87.7421 35.1547 87.7421H77.3068C78.1053 87.7421 78.8711 87.3965 79.4358 86.7814C80.0004 86.1663 80.3176 85.3321 80.3176 84.4622V25.4236C80.3176 24.5537 80.0004 23.7194 79.4358 23.1043C78.8711 22.4892 77.3068 22.1437 77.3068 22.1437Z"
            fill="#E3E3E3"
          />
          <path
            d="M42.3938 36.4933H62.8149"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 42.6432H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 48.7931H62.8149"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 54.9427H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 61.0927H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 67.2426H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 73.3928H62.8149"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="31.7168"
            y="21.7166"
            width="49.028"
            height="66.4525"
            rx="3.502"
            stroke="#191919"
            strokeWidth="1.1958"
          />
          <path
            d="M97.6088 57.4826L95.6912 59.4002L89.2993 53.0083L91.2169 51.0907C92.0691 50.2657 93.2115 49.8088 94.3976 49.8184C95.5838 49.828 96.7186 50.3035 97.5573 51.1422C98.3961 51.981 98.8715 53.1158 98.8811 54.3019C98.8908 55.488 98.4338 56.6304 97.6088 57.4826Z"
            fill="#FF808C"
          />
          <path
            d="M82.3193 72.7719L73.3706 75.3287L75.9274 66.38L82.3193 72.7719Z"
            fill="#FFBC44"
          />
          <path
            d="M89.2991 53.0109L75.9272 66.3828L82.3191 72.7747L95.691 59.4028L89.2991 53.0109Z"
            fill="#FFEF5E"
          />
          <path
            d="M97.6088 57.4826L95.6912 59.4002L89.2993 53.0083L91.2169 51.0907C92.0691 50.2657 93.2115 49.8088 94.3976 49.8184C95.5838 49.828 96.7186 50.3035 97.5573 51.1422C98.3961 51.981 98.8715 53.1158 98.8811 54.3019C98.8908 55.488 98.4338 56.6304 97.6088 57.4826Z"
            stroke="#191919"
            strokeWidth="1.1958"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.3193 72.7719L73.3706 75.3287L75.9274 66.38L82.3193 72.7719Z"
            stroke="#191919"
            strokeWidth="1.1958"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.2991 53.0109L75.9272 66.3828L82.3191 72.7747L95.691 59.4028L89.2991 53.0109Z"
            stroke="#191919"
            strokeWidth="1.1958"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
